/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * WordPress dependencies
 */
import { Button, SelectControl, HStack } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import OverflowControlIcon from '../icon';

export const StyledSelectControl = styled( SelectControl )`
	width: 100%;

	.components-select-control__input[disabled] {
		cursor: auto;
	}
}
`;

export const SelectWrapper = styled( HStack )`
	grid-column: 1 / span 3;

	.components-base-control {
		flex-grow: 1;
	}
`;

export const ResetButton = styled( Button )`
	grid-area: 1 / 2;
	justify-self: end;
`;

export const LinkedButtonWrapper = styled.div`
	grid-area: 1 / 3;
	justify-self: end;
`;

export const FlexedBoxControlIcon = styled( OverflowControlIcon )`
	flex: 0 0 auto;
`;
